export default __webpack_public_path__ + "static/media/mail.c695f700.svg";